@if (mode$|async; as mode) {
  <div class="mb-4">
    @if (mode === 'Edit') {
      <app-add-button class="mb-4" id="add-link" (click)="openModal()"></app-add-button>
    }
    @if (links$|async; as links) {
      @if (links.length > 0) {
        @for (link of links; track link) {
          <a [href]="link.link" target="_blank" class="flex items-center h-12 pl-4 pr-3 mb-1 shadow-sm border border-solid border-neutral-3 text-dark rounded hover:no-underline hover:bg-neutral-4 w-full">
            <div class="flex flex-1 mr-1 items-center overflow-hidden">
              <vwui-icon class="vwui-icon-file mr-2 shrink-0" iconName="files-icon-docx"></vwui-icon>
              <span class="block truncate">{{link.name}}</span>
            </div>
            <div class="flex items-center">
              <div class="bg-dark bg-opacity-8 px-2 text-sm rounded mr-1 shrink-0">{{link.type.value}}</div>
              @if (mode === 'Edit') {
                <vwui-btn-icon icon="vwui-edit" (click)="openModal($event, link)"></vwui-btn-icon>
                <vwui-btn-icon icon="vwui-trash" (click)="deleteMember($event, link)"></vwui-btn-icon>
              }
            </div>
          </a>
        }
      } @else {
        <vwui-empty-state messageTitle="Geen documenten" message="Er zijn nog geen documenten toegevoegd"></vwui-empty-state>
      }
    }
  </div>
}

